import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, Scroll } from '@angular/router';
import { filter, map } from 'rxjs';

interface BreadcrumbItem {
  label: string;
  url: string;
}

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

  public static ROUTE_DATA_BREADCRUMB = 'breadcrumb';
  public breadcrumbs: BreadcrumbItem[] = [];

  constructor(private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.updateBreadcrumbs();
    this.router.events
      .pipe(
        filter(
          (event) =>
            event instanceof NavigationEnd ||
            (event instanceof Scroll && event.routerEvent instanceof NavigationEnd)
        ),
        map((event) =>
          event instanceof Scroll
            ? (event.routerEvent as NavigationEnd)
            : (event as NavigationEnd)
        )
      )
      .subscribe(() => {
        this.updateBreadcrumbs();
      });
  }

  private createBreadcrumbs(
    route: ActivatedRoute,
    url: string = '',
    breadcrumbs: BreadcrumbItem[] = []
  ) {
    const children: ActivatedRoute[] = route.children;
    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      const routeURL: string = child.snapshot.url
        .map((segment) => segment.path)
        .join('/');
      if (routeURL !== '') {
        url += `/${routeURL.trim()}`;
      }

      const label: string =
        child.snapshot.data[BreadcrumbComponent.ROUTE_DATA_BREADCRUMB];

      if (url.includes('/criar-vaga') || url.includes('/editar-vaga') || url.includes('/visualizar-vaga') ||
        url.includes('/gerenciar-vaga') || url.includes('/inscritos')) {
        if (!breadcrumbs.some(b => b.label === 'Vagas')) {
          breadcrumbs.push({ label: 'Vagas', url: '/' });
        }
      }

      if (label) {
        breadcrumbs.push({ label, url });
      }

      return this.createBreadcrumbs(child, url, breadcrumbs);
    }
  }

  private updateBreadcrumbs() {
    this.breadcrumbs = this.createBreadcrumbs(this.route.root);

    const title = this.route.snapshot.queryParamMap.get('title');
    if (title && this.breadcrumbs.length > 0) {
      this.breadcrumbs[this.breadcrumbs.length - 1].label = title;
    }
    this.breadcrumbs[this.breadcrumbs.length - 1].url = "/"
  }
}
